<template>
    <b-tabs lazy>
        <div class="sub-tabs-bg">
            <s-img src="/assets/img/games-page/bg-tabs.png" class="bg-subs-tab-pc" alt="Las Vegas"/>
            <s-img src="/assets/img/games-page/bg-tabs-mobile.png" alt="Las Vegas" class="bg-subs-tab-mb"/>
        </div>
        <b-tab v-for="(tab, index) in tabs"
            :key="index"
            :active="index == activeTab"
            @click.prevent="setActive(tab, index)">
            <template v-slot:title>
                <div class="tab-title">
                    <s-img :src="tabsImage[index].desktop" alt="Las Vegas"/>
                </div>
            </template>
            <div class="sub-tabs">
                <sub-tabs
                    v-show="activeTab===index"
                    :isShow="activeTab===index"
                    :name="index"
                    :data="tabs[index]"
                    :icon="gameIcon"
                    :type="type[index]"
                    :gameParentType="activeTab"/>
            </div>
        </b-tab>
    </b-tabs>
</template>

<script>

// eslint-disable-next-line import/no-unresolved
import subTabs from './subTabs.vue';

export default {
    props: ['tabs', 'currentTab', 'type'],
    components: {
        subTabs
    },
    computed: {
    },
    data() {
        return {
            activeTab: this.currentTab,
            tabsImage: {
                vegas: {
                    desktop: `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/tab-vegas.png`,
                    mobile: `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/tab-vegas.png`
                },
                macau: {
                    desktop: `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/tab-macau.png`,
                    mobile: `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/tab-macau.png`
                }
            },
            gameIcon: {
                'tat-ca': `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-all.svg`,
                'game-bai': `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-game-bai.svg`,
                'danh-bai': `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-table-game.svg`,
                'battle-game': `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-battle-game.svg`,
                'no-hu': `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-slot.svg`,
                'no-hu-vegas': `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-slot.svg`,
                ingame: `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-in-game.svg`,
                'ban-ca': `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-fish.svg`,
                'tro-choi-khac': `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-another.svg`,
                'no-hu-18': `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-slot-18.png`,
                'no-hu-vegas-18': `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-slot-18.png`,
                spribe: `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-slot-18.png`,
                evo: `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-in-game.svg`,
                'quay-so': `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-lottery.svg`
            }
        };
    },
    watch: {
        currentTab() {
            this.activeTab = this.currentTab;
        }
    },
    methods: {
        setActive(tab, index) {
            this.activeTab = index;
            this.$router.push({ query: { tab: index, type: this.type[index] } });
        }
    }
};
</script>
